// extracted by mini-css-extract-plugin
export default {"container":"about-ownership_container__PK7oY"};